// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Choice_main__0KQGT {

    height: auto;
    max-width: 400px;
    background: #3a0303;
    padding: 30px 10px;
    border-radius: 10px;

}
.Choice_containerButtons__J-gxd{
    margin-top: 30px;
    display: flex;
    justify-content: center;
    gap:40px;

}
.Choice_text__EIM6R{
    display: flex;
    justify-content: center;
    text-align: center;
    font-size: 18px;

    font-family: "Montserrat", sans-serif;

    color:white;
}`, "",{"version":3,"sources":["webpack://./src/components/Modals/components/Choice/Choice.module.css"],"names":[],"mappings":"AAAA;;IAEI,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;;AAEvB;AACA;IACI,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,QAAQ;;AAEZ;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;;IAEf,qCAAqC;;IAErC,WAAW;AACf","sourcesContent":[".main {\n\n    height: auto;\n    max-width: 400px;\n    background: #3a0303;\n    padding: 30px 10px;\n    border-radius: 10px;\n\n}\n.containerButtons{\n    margin-top: 30px;\n    display: flex;\n    justify-content: center;\n    gap:40px;\n\n}\n.text{\n    display: flex;\n    justify-content: center;\n    text-align: center;\n    font-size: 18px;\n\n    font-family: \"Montserrat\", sans-serif;\n\n    color:white;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `Choice_main__0KQGT`,
	"containerButtons": `Choice_containerButtons__J-gxd`,
	"text": `Choice_text__EIM6R`
};
export default ___CSS_LOADER_EXPORT___;
